import { render, staticRenderFns } from "./LimitProductEdit.vue?vue&type=template&id=d1dd66d0&"
import script from "./LimitProductEdit.vue?vue&type=script&lang=js&"
export * from "./LimitProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports